import $i18n from 'panda-i18n';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { CnDrawer } from '@/components/cn-drawer';
import { CnButton } from '../../cn-button';
export default (props) => {
    const { prefix = 'cn-ui-m-', visible = false, drawerClassName, drawerTitle, onCancel, onClose, onOk, children, ...others } = props;
    const [drawerVisible, setDrawerVisible] = useState(false);
    const clsPrefix = `${prefix}selectdrawer`;
    useEffect(() => {
        if (drawerVisible !== visible) {
            setDrawerVisible(visible);
        }
    }, [visible]);
    return (React.createElement(CnDrawer, { ...others, visible: drawerVisible, placement: "bottom", closeMode: ['mask'], onClose: onClose, className: classNames(`${clsPrefix}-drawer`, drawerClassName), noCard: true },
        React.createElement("div", { className: `${clsPrefix}-toolbar` },
            React.createElement(CnButton, { text: true, onClick: onCancel }, $i18n.get({ id: 'Cancel', dm: '取消', ns: 'CnSelect' })),
            React.createElement("div", { className: `${clsPrefix}-toolbar-title` }, drawerTitle),
            React.createElement(CnButton, { text: true, type: "primary", onClick: onOk }, $i18n.get({ id: 'Confirm', dm: '确认', ns: 'CnSelect' }))),
        React.createElement("div", { className: `${clsPrefix}-drawer-content` }, children)));
};
